/* RESPONSIBLE TEAM: team-standalone */

import RulesetLinkSerializer from 'embercom/serializers/matching-system/ruleset-link';

export default RulesetLinkSerializer;
